import { Parser } from 'html-to-react';

export function parseHtmlToReact(html){
    return new Parser().parse(html);
}